import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";

const LOGO_FIRMA = "https://customer-assets.emergentagent.com/job_subasta-deuda-report/artifacts/60a5lh2u_logo%20Horizontal%20firma.png";
const LOGO_VERTICAL = "https://customer-assets.emergentagent.com/job_subasta-deuda-report/artifacts/abkfwdtb_Logo%20Vertical%20Negativo.png";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await login(email, password); navigate("/admin"); }
    catch (e) { setError(formatApiError(e.response?.data?.detail) || e.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-stone-50">
      <SEO title="Acceso Admin" path="/admin/login" noindex />
      <div className="flex items-center justify-center p-8 lg:p-16 bg-white relative">
        <div className="absolute top-6 left-6 lg:left-16">
          <img src={LOGO_FIRMA} alt="Fernando Marcos" className="h-12 object-contain invert" style={{ filter: "none" }} />
        </div>
        <div className="w-full max-w-sm">
          <div className="text-[11px] tracking-[0.25em] uppercase font-bold text-[#E0651F] mb-4">Acceso Admin</div>
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight leading-none text-[#2d1f1a] mb-3">
            Panel interno.
          </h1>
          <p className="text-stone-500 text-sm mb-10 leading-relaxed">
            Acceso reservado al equipo de Fernando Marcos Subastas &amp; Investment para la generación interna de informes de cargas siguiendo el protocolo de 16 fases.
          </p>
          <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="block text-[10px] tracking-[0.25em] uppercase font-bold text-stone-500 mb-2">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                className="w-full px-3 py-2.5 border border-stone-300 rounded-sm bg-white focus:outline-none focus:border-[#E0651F] focus:ring-1 focus:ring-[#E0651F] text-sm"
                data-testid="login-email-input" />
            </div>
            <div>
              <label className="block text-[10px] tracking-[0.25em] uppercase font-bold text-stone-500 mb-2">Contraseña</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                className="w-full px-3 py-2.5 border border-stone-300 rounded-sm bg-white focus:outline-none focus:border-[#E0651F] focus:ring-1 focus:ring-[#E0651F] text-sm"
                data-testid="login-password-input" />
            </div>
            {error && <div className="text-xs text-red-600 bg-red-50 border border-red-200 px-3 py-2 rounded-sm" data-testid="login-error">{error}</div>}
            <button type="submit" disabled={loading}
              className="w-full bg-[#2d1f1a] hover:bg-[#E0651F] text-white py-3 text-sm font-bold tracking-wider uppercase rounded-sm transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
              data-testid="login-submit-button">
              {loading ? "Entrando..." : <>Entrar <ArrowRight className="w-4 h-4" /></>}
            </button>
          </form>
          <div className="mt-8 text-xs text-stone-500">
            Acceso reservado para el equipo de Fernando Marcos Subastas. ¿Eres cliente?{" "}
            <Link to="/" className="text-[#E0651F] hover:underline font-bold" data-testid="go-site-link">Volver a la web</Link>
          </div>
        </div>
      </div>
      <div className="hidden lg:flex items-center justify-center bg-[#2d1f1a] p-16 relative overflow-hidden">
        <img src={LOGO_VERTICAL} alt="" className="max-w-md w-full object-contain relative z-10" />
        <div className="absolute bottom-12 left-16 right-16 text-stone-300 z-10">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#E0651F] mb-3">Sistema profesional</div>
          <div className="font-display text-2xl xl:text-3xl font-black leading-tight max-w-md text-white">
            Detecta riesgos reales. Determina qué cargas subsisten.
          </div>
        </div>
      </div>
    </div>
  );
}
